import React from "react";

import SvgIcon from "@material-ui/core/SvgIcon";
import { SvgIconProps } from "@material-ui/core/SvgIcon";

export const FilterIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 20 20", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <g>
                <path
                    fill="#21006E"
                    d="M17.9,6c-0.2-1.1-1.2-2-2.4-2s-2.2,0.9-2.4,2H1v1h12.1c0.2,1.1,1.2,2,2.4,2s2.2-0.9,2.4-2H19V6H17.9z
		 M15.5,8C14.7,8,14,7.3,14,6.5S14.7,5,15.5,5S17,5.7,17,6.5S16.3,8,15.5,8z"
                />
                <path
                    fill="#21006E"
                    d="M4.5,11c-1.2,0-2.2,0.9-2.4,2H1v1h1.1c0.2,1.1,1.2,2,2.4,2s2.2-0.9,2.4-2H19v-1H6.9C6.7,11.9,5.7,11,4.5,11
		z M4.5,15C3.7,15,3,14.3,3,13.5S3.7,12,4.5,12S6,12.7,6,13.5S5.3,15,4.5,15z"
                />
            </g>
        </SvgIcon>
    );
};
